import { render, staticRenderFns } from "./entidad_bancaria.vue?vue&type=template&id=02a810d3&"
import script from "./entidad_bancaria.vue?vue&type=script&lang=js&"
export * from "./entidad_bancaria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports